export const TabHeader = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  return (
    <div>
      <div className="text-gray-900 text-sm font-medium">{title}</div>
      <div className="text-gray-700 text-sm">{description}</div>
    </div>
  );
};
